import {z} from 'zod';
import {ELEMENT} from '../../elements/base/ElementTypes';
import {questionBaseValidator} from './questionBase';

export const photoAnswerQuestionValidator = questionBaseValidator.extend({
    type: z.literal(ELEMENT.PHOTO_ANSWER_QUESTION),
});
